import { render } from "./HomeInfo.vue?vue&type=template&id=b31b53ec&scoped=true"
import script from "./HomeInfo.vue?vue&type=script&lang=js"
export * from "./HomeInfo.vue?vue&type=script&lang=js"

import "./HomeInfo.vue?vue&type=style&index=0&id=b31b53ec&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\kyleb\\OneDrive\\Documenten\\Tess website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b31b53ec"]])

export default __exports__